<div class="header wrapper mar_btm20">
    <div class="wrapper-size">
        <div class="header-logo">
            <img src="../../inc/img/logo.png" class="logo_only" alt="" height="38" />
        </div>
    </div>
</div>
<div id="contact" class="wrapper add_menu_ht">
    <div class="wrapper-size">
        <div class="page">

            <div class="page-header" *ngIf="showTitle">
                <div class="page-header-title">{{title}}</div>
            </div>

            <div class="page-body">
                <div id="header" class="wrapper"></div><!-- #header end-->
                <div id="contact" class="wrapper">
                    <div class="wrapper-size">
                        <div class="page">
                            <div class="page-header">
                                <div class="pull-right txt_time">
                                    <span *ngIf = "isValidDate(systemOperationTime)">{{systemOperationTime | date :'yyyy/MM/dd HH:mm:ss (Z)'}} {{currentArea}}</span>
                                    <span *ngIf = "!isValidDate(systemOperationTime)">{{systemOperationTime}} {{currentArea}}</span>
                                </div>
                            </div> 
                            <div class="page-body page-body-error-mag">
                                <div class="alert alert-danger">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    {{errorTitle}}<span [innerHTML]="errorDesc | safeHtml"></span>
                                    <!-- <strong>Oh snap!</strong> Change a few things up and try submitting again. -->
                                </div>
                                <div class="btn_box">
                                    <commandButton [mask]="true" [valid]="true" (onClick)="doBackHome($event)">
                                        {{backToHomeButtonLabel}}</commandButton>
                                </div>
                            </div><!-- / page-body -->
                        </div><!-- / page-page-->
                        <!-- / info -->
                    </div>
                    <!--/ wrapper-size-->
                </div><!-- #contact end-->
            </div>
        </div>
    </div>
</div>